import HomePageBase from '../../components/home/templates/HomePageBase.jsx';

export default {
    'home-base': {
        component: HomePageBase,
        query: ``,
        propertiesMapping: {
            content: 'content',
            'mainCreativeWork.creativeWorkStatus': 'creativeWorkStatus',
        },
    },
};
